import React from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

export const StyledRow = styled(
  ({
    isStartEnd,
    dispatch,
    published,
    isFinishedOrSkipped = false,
    stop,
    ...rest
  }) => {
    return <Grid {...rest} />;
  }
)`
  height: 55px;
  align-items: stretch !important;
  page-break-inside: avoid;
  position: relative;
  transition: box-shadow 0.2s cubic-bezier(0.2, 0, 0, 0.1),
    opacity 0.2s cubic-bezier(0.2, 0, 0, 0.1),
    background-color 0.2s cubic-bezier(0.2, 0, 0, 0.1);
  background-color: #fff;

  ${props =>
    props.published && {
      cursor: "pointer"
    }}

  ${props =>
    props.active
      ? {
          backgroundColor: "#F8F9FF",
          borderBottomColor: "transparent !important"
        }
      : props.activeByListCommand && !props.haveHovered
      ? {
          backgroundColor: "#F4F4F4",
          borderBottomColor: "transparent !important"
        }
      : props.selected
      ? {
          backgroundColor: "#F4F4F4",
          borderBottomColor: "transparent !important"
        }
      : null}
  
  ${props =>
    !props.isStartEnd
      ? `
      &:hover {
        background-color: #F4F4F4;
      
      ${
        !props.published &&
        `
        > .fourth-col {
          p {
            // opacity: 0;
          }

          .edit-remove-btns {
            opacity: 1;
          }
        }
      `
      }
      }
  `
      : `
      
  `}

  .requirement-icon {
    font-size: 0.9375rem;
    margin-right: 6px;
    color: #808080;
  }

  .dash-icon {
    font-size: 0.8125rem;
    color: #7d7e82;
  }

  .text-13 {
    font-size: 0.8125rem;
  }

  .font-weight-medium {
    font-weight: 500;
  }

  > .fourth-col {
    p {
      transition: opacity 0.3s;
    }

    // Action buttons
    .edit-remove-btns {
      opacity: 0;
      transition: opacity 0.3s;
      align-self: center;
      display: flex;
      align-items: center;
      height: 100%;
      position: absolute;
      top: 0;
      right: 12px;

      button {
        margin-left: 14px;
      }
    }
  }

  .stop-break {
    color: #808080;
  }

  .stop-finished {
    color: #808080;
  }

  .route-not-started {
    color: #202124;
  }

  .stop-status-icon {
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.54);
    margin-right: 0.6rem;
  }

  .stop-late {
    .stop-status-icon {
      color: #feb700;
    }
  }

  .stop-note {
    font-size: 1rem;
    margin-right: 0.4rem;
    color: #202124;
  }

  .stop-on-time {
    color: #1da25e;
  }

  // Drag item
  .drag-icon {
    opacity: 0;
    transition: opacity 0.3s;
  }

  &.drag-item {
    &.is-dragging {
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.16), 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    .select-icon {
      display: none;
      margin-left: -2px;
      svg: {
        color: inherit;
      }
    }

    &:hover,
    .selected {
      .select-icon {
        display: block;
      }
    }

    &:hover .drag-icon {
      opacity: 1;
    }
  }

  .requirements-wrapper {
    display: flex;
    align-items: center;
    height: 15px;
  }

  .drag-icon-wrapper {
    display: flex;
    position: absolute;
    align-items: center;
    left: 4px;
  }

  .unassigned-indicator {
    width: 10px;
    padding-left: 4px;
  }

  .count-indicator {
    display: none;
    position: absolute;
    top: -12px;
    right: -12px;
    width: 24px;
    height: 24px;
  }

  .unassigned-indicator {
    color: #202124;
  }

  &.is-dragging .count-indicator {
    display: flex;
  }

  .count-indicator-label {
    padding: 0;
  }

  .eta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &.finished-or-skipped {
    & .first-col,
    & .second-col,
    & .third-col {
      opacity: 0.5;
    }

    &:hover .first-col,
    &:hover .second-col,
    &:hover .third-col {
      opacity: 1;
    }
  }
`;

export const StyledCell = styled(
  ({ isStartEnd, isReload, finished, print, ...rest }) => <Grid {...rest} />
)`
  padding: 0 0.5rem;

  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  ${props => !props.print && { borderBottom: "1px solid #eee !important" }}

  &.first-col {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 0;
    flex-shrink: 0;
    width: 64px;
    max-width: 64px;
    flex-basis: 64px;
    padding-left: 17px;
  }

  &.second-col {
    width: ${({ isStartEnd, isReload }) =>
      isStartEnd ? "50%" : isReload ? "80%" : "41%"};
    max-width: ${({ isStartEnd, isReload }) =>
      isStartEnd ? "50%" : isReload ? "80%" : "41%"};
    flex-basis: ${({ isStartEnd, isReload }) =>
      isStartEnd ? "50%" : isReload ? "80%" : "41%"};
    flex-grow: 0;
    flex-shrink: 0;
  }

  &.third-col {
    width: ${({ isStartEnd, isReload }) =>
      isStartEnd || isReload ? "1%" : "20%"};
    max-width: ${({ isStartEnd, isReload }) =>
      isStartEnd || isReload ? "1%" : "20%"};
    flex-basis: ${({ isStartEnd, isReload }) =>
      isStartEnd || isReload ? "1%" : "20%"};
    flex-grow: 0;
    flex-shrink: 0;
  }

  &.fourth-col {
    flex-basis: 0;
    flex-grow: 1;
    text-align: right;
    padding-left: 0;
    padding-right: 12px;
  }

  .svg-icon {
    width: 20px;
    height: 20px;
  }

  .wait-icon {
    color: #d93024;
  }
`;
